class ClaimCategory {
  constructor(data) {
    data = data || {};
    this.id = data.id || null;
    this.name = data.name || null;
    this.name_l10n = data.name_l10n || [];
    this.active = data.active || null;
    this.constant = data.constant || null;
    this.display_order = data.display_order || null;
  }

  get isTimeBased() {
    return this.constant === 'CLAIM_CATEGORY_TIME';
  }

  get isDistanceBased() {
    return this.constant === 'CLAIM_CATEGORY_DISTANCE';
  }

  get isAmountBased() {
    return this.constant === 'CLAIM_CATEGORY_AMOUNT';
  }
}

export default ClaimCategory;
